import React from "react";
import moment from "moment";
export default function ({ date }) {
  return <span>{moment(date).format("MMM DD, YYYY")}</span>;
}
